enum FormulaType {
    number = 'number',
    datetime = 'datetime',
    renewal = 'renewal'
}

export default FormulaType;